// extracted by mini-css-extract-plugin
export default {"Left":"Create_Left__187rx","BevzLogoText":"Create_BevzLogoText__w598m","Left_subheading":"Create_Left_subheading__1Ta5m","Right":"Create_Right__SzY0p"};